import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AuthError } from '../../components/errors/AuthError.tsx'

export const Route = createFileRoute('/_public/auth/error')({
	validateSearch: z.object({
		code: z.string().optional(),
	}),
	component: AuthError,
})
